import { CatalogCompany } from '@/shared/types/catalog';

export const getSupplierAvatar = (supplier: CatalogCompany) => {
  return supplier?.avatarUrl || supplier?.user?.avatarUrl;
};
